import React from "react";
import { ArrowRight } from "lucide-react";

// Popular Canadian recreational vehicle transport lanes — long-tail SEO goldmine
const ROUTES = [
  { from: "Calgary, AB", to: "Toronto, ON", type: "RV transport", km: "3,400" },
  { from: "Vancouver, BC", to: "Halifax, NS", type: "Motorcycle shipping", km: "5,750" },
  { from: "Edmonton, AB", to: "Montréal, QC", type: "RV & motorhome", km: "3,650" },
  { from: "Winnipeg, MB", to: "Kelowna, BC", type: "Snowmobile transport", km: "1,850" },
  { from: "Toronto, ON", to: "Whitehorse, YT", type: "ATV & side-by-side", km: "5,200" },
  { from: "Québec City, QC", to: "Victoria, BC", type: "Boat hauling", km: "5,100" },
  { from: "Saskatoon, SK", to: "St. John's, NL", type: "RV hauling", km: "5,450" },
  { from: "Ottawa, ON", to: "Calgary, AB", type: "Motorcycle transport", km: "3,500" },
  { from: "Mississauga, ON", to: "Vancouver, BC", type: "Jet ski & PWC", km: "4,350" },
];

export default function Routes() {
  return (
    <section
      id="routes"
      className="bg-[#F4F4F1] border-b-2 border-[#122A1E]"
      data-testid="routes-section"
      aria-labelledby="routes-heading"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-20 md:py-28">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-10">
          <div>
            <div className="font-mono-accent text-[11px] uppercase text-[#4A5550] mb-3">
              ◆ 007 · Popular Routes
            </div>
            <h2
              id="routes-heading"
              className="font-display font-black uppercase tracking-tighter leading-none text-[#0A0E0C] text-4xl md:text-5xl"
            >
              Coast-to-Coast
              <br />
              Transport Lanes.
            </h2>
          </div>
          <p className="font-body text-[#4A5550] md:max-w-md text-base leading-relaxed">
            The most-booked Canadian RV, motorcycle, ATV, snowmobile and boat
            transport routes on our network. All runs available year-round —
            book your exact route in the quote form above.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-[2px] bg-[#122A1E] border-2 border-[#122A1E]">
          {ROUTES.map((r, i) => (
            <a
              key={i}
              href="#quote"
              className="group bg-[#F4F4F1] p-6 hover:bg-[#EAEAE5] transition-colors flex flex-col justify-between"
              data-testid={`route-${i}`}
            >
              <div>
                <div className="font-mono-accent text-[10px] uppercase text-[#FF5A00] mb-3">
                  {r.type} · {r.km} km
                </div>
                <div className="font-display font-black uppercase text-xl md:text-2xl tracking-tight leading-tight text-[#0A0E0C]">
                  {r.from}
                </div>
                <div className="font-mono-accent text-[10px] uppercase text-[#4A5550] my-1">
                  ↓ to
                </div>
                <div className="font-display font-black uppercase text-xl md:text-2xl tracking-tight leading-tight text-[#0A0E0C]">
                  {r.to}
                </div>
              </div>
              <div className="mt-5 pt-4 border-t-2 border-[#D2CEBD] flex items-center justify-between font-mono-accent text-[10px] uppercase text-[#122A1E] group-hover:text-[#FF5A00]">
                <span>Get Quote for This Run</span>
                <ArrowRight size={14} />
              </div>
            </a>
          ))}
        </div>

        {/* Hidden SEO copy — visible to users + Google; reinforces keyword context */}
        <div className="mt-10 text-[#4A5550] text-sm leading-relaxed max-w-4xl">
          <p>
            Marine &amp; Recreational Hauling runs dedicated Canadian transport
            lanes between every major city — from{" "}
            <strong>Vancouver and Victoria in British Columbia</strong> through{" "}
            <strong>Calgary and Edmonton in Alberta</strong>,{" "}
            <strong>Saskatoon and Regina in Saskatchewan</strong>,{" "}
            <strong>Winnipeg in Manitoba</strong>, across to{" "}
            <strong>Toronto, Ottawa and Mississauga in Ontario</strong>,{" "}
            <strong>Montréal and Québec City in Quebec</strong>, and out to{" "}
            <strong>Moncton, Halifax, Charlottetown and St. John's</strong> on
            the East Coast. Northern runs to <strong>Whitehorse, Yukon</strong>{" "}
            are available on request. Whether
            you need RV shipping, enclosed motorcycle transport, ATV or
            side-by-side hauling, snowmobile delivery or marine boat
            transport, our trucks cover the route — directly, no brokers.
          </p>
        </div>
      </div>
    </section>
  );
}
